// src/locales/en/orders.js
export const orders = {
    newOrder: "புதிய ஆர்டர்",
    orderNumber: "ஆர்டர் #{{number}}",
    customer: "வாடிக்கையாளர்",
    amount: "தொகை",
    date: "தேதி",
    status: "நிலை",
    pending: "நிலுவையில்",
    processing: "செயலாக்கப்படுகிறது",
    shipped: "அனுப்பப்பட்டது",
    delivered: "வழங்கப்பட்டது",
    cancelled: "ரத்துசெய்யப்பட்டது",
    returned: "திரும்பியது"
}